    window.addEventListener('DOMContentLoaded', (e) => {
      setVarsOnResize();
    });
    function setVarsOnResize() {
      window.addEventListener('resize', resizeVars);
      resizeVars()
    }

  function resizeVars() {
    // restrict the heights that are changed on resize to avoid iOS jump when URL bar is shown and hidden
    windowHeight = Math.min(window.screen.height, window.innerHeight);
    document.documentElement.style.setProperty('--two-thirds', `${windowHeight * (2 / 3)}px`);
    document.documentElement.style.setProperty('--three-quarters', `${windowHeight * (3 / 4)}px`);
  }


const selectors = {
  deferredMediaButton: '[data-deferred-media-button]',
  media: 'video, model-viewer, iframe',
  youtube: '[data-host="youtube"]',
  vimeo: '[data-host="vimeo"]',
  productGridItem: '[data-grid-item]',
  section: '.shopify-section',
  template: 'template',
  video: 'video',
  productModel: 'product-model',
};

const attributes = {
  loaded: 'loaded',
  autoplay: 'autoplay',
};

class CustomDeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector(selectors.deferredMediaButton);
    poster?.addEventListener('click', this.loadContent.bind(this));
    this.section = this.closest(selectors.section);
    this.productGridItem = this.closest(selectors.productGridItem);
    this.hovered = false;

    this.mouseEnterEvent = () => this.mouseEnterActions();
    this.mouseLeaveEvent = () => this.mouseLeaveActions();
  }

  loadContent(focus = true) {
    this.pauseAllMedia();
    if (!this.getAttribute(attributes.loaded)) {
      const content = document.createElement('div');
      const templateContent = this.querySelector(selectors.template).content.firstElementChild.cloneNode(true);
      content.appendChild(templateContent);
      this.setAttribute(attributes.loaded, true);

      const mediaElement = this.appendChild(content.querySelector(selectors.media));
      if (focus) mediaElement.focus();
      if (mediaElement.nodeName === 'VIDEO' && mediaElement.getAttribute(attributes.autoplay)) {
        mediaElement.play();
      }
    }
  }

  pauseAllMedia() {
    document.querySelectorAll(selectors.youtube).forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
    document.querySelectorAll(selectors.vimeo).forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll(selectors.video).forEach((video) => video.pause());
  }
}

const videoSelectors = {
  videoTemplate: '[data-video-template]',
};

const videoClasses = {
  loading: 'is-loading',
};

const videoAttributes = {
  videoId: 'data-video-id',
};

class VideoBackground extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.videoId = this.getAttribute(videoAttributes.videoId);
    this.videoTemplate = this.querySelector(videoSelectors.videoTemplate);
    this.video = null;

    if (this.videoId) {
      this.renderVideo();
    }
  }

  renderVideo() {
    this.videoTemplateObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const content = this.videoTemplate.innerHTML;
            this.innerHTML = content;
            this.classList.remove(videoClasses.loading);
            this.video = this.querySelector('video');
            this.observeVideoPlayToggle();
          }
        });
      },
      { rootMargin: '0px', threshold: 0.5 }
    );

    this.videoTemplateObserver.observe(this);
  }

  observeVideoPlayToggle() {
    if (!this.video) return;

    const options = {
      rootMargin: '0px',
      threshold: [0, 1.0],
    };

    this.videoPlayObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isVisible = entry.isIntersecting;
        if (isVisible && typeof this.video.play === 'function') {
          this.video.play();
        }
        if (!isVisible && typeof this.video.pause === 'function') {
          this.video.pause();
        }
      });
    }, options);

    this.videoPlayObserver.observe(this.video);
  }
}

// Register the custom elements
if (!customElements.get('custom-deferred-media')) {
  customElements.define('custom-deferred-media', CustomDeferredMedia);
}

if (!customElements.get('video-background')) {
  customElements.define('video-background', VideoBackground);
}